
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent",
      function () {
        return require("private-next-pages/talent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent"])
      });
    }
  